'use client';

import type { ReactNode } from 'react';
import { MarkdownPreview } from '../../../../markdown-preview';
import type { HITLContentContext } from '../../tool-config-types';

export const renderMarkdownContent = (ctx: HITLContentContext): ReactNode => {
  const source =
    typeof ctx.args === 'string' ? ctx.args : JSON.stringify(ctx.args, null, 2);
  return <MarkdownPreview source={source} />;
};
